module.exports = __webpack_public_path__ + "img/6.e3284105.jpg";